module.exports = __webpack_public_path__ + "static/postel-0c75fb2038af0c63f4631ebb08c173ca.svg";